import { useToasts } from 'react-toast-notifications';
import { useCallback } from 'react';
import { merge } from 'lodash';
var defaultOptions = {
    autoDismiss: true,
};
var useToast = function () {
    var _a = useToasts(), defaultAddToast = _a.addToast, removeToast = _a.removeToast, removeAllToasts = _a.removeAllToasts;
    var addToast = useCallback(function (content, appearance, options) {
        if (appearance === void 0) { appearance = 'error'; }
        return defaultAddToast(content, merge(defaultOptions, options, { appearance: appearance }));
    }, [defaultAddToast]);
    return { addToast: addToast, removeToast: removeToast, removeAllToasts: removeAllToasts };
};
export default useToast;
//# sourceMappingURL=useToast.js.map